import { scaleLinear } from 'd3';

export const getThumbSizeAtScale = (scale: number) => {
  return 80 * Math.pow(1 / scale, 0.7);
}

export const getIconSizeAtScale = (scale: number) => {
  return 8 * Math.pow(1 / scale, 0.6);
}

export const getStrokeWidthAtScale = scaleLinear().domain([1, 30]).range([0.5, 0.05]);

export const getFontSizeAtScale = (scale: number) => {
  return 70 * Math.pow(1 / scale, 0.725);
}

export const getXOffsetAtScale = scaleLinear().domain([1, 6]).range([1, 0.5]).clamp(true);
